import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import FeedbackIllustration from '../images/incoming-feedback.png';

export const S = {
  Container: styled.div`
    align-items: stretch;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: ${tokens.spacer.x3};
  `,
  IllustrationWrapper: styled.div`
    max-width: 40%;
  `,
  Illustration: styled.img`
    display: block;
    height: 150px;
    object-fit: contain;
    width: 230px;
  `,
};

export const AskBar = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <S.Container data-testid="plan-selection-modal-ask-content">
      {children}
      <S.IllustrationWrapper>
        <S.Illustration src={FeedbackIllustration} />
      </S.IllustrationWrapper>
    </S.Container>
  );
};
